import {
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    Output,
} from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';

import { TranslationKeyMap } from './user.component.i18n';

@Component({
    selector: 'cmps-ciw-user',
    templateUrl: './user.component.html',
})
export class UserComponent implements OnDestroy {
    @Input() imageUrl: SafeResourceUrl;
    @Output() select: EventEmitter<number>;
    @Output() search: EventEmitter<MouseEvent | KeyboardEvent>;

    /** @private */
    readonly _i18n = TranslationKeyMap;

    constructor() {
        this.select = new EventEmitter();
        this.search = new EventEmitter();
    }

    ngOnDestroy(): void {
        this.select.complete();
        this.search.complete();
    }
}
